export default __webpack_public_path__ + "static/media/ckd.f80cf9d9.svg";